import {CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select} from '@material-ui/core';
import * as AWDStatusActions from 'ApplicationEntry/ducks/AWDStatus';
import {isLoaded, isLoading, matchStatus, Status} from 'ApplicationEntry/models/AWDStatus/Status';
import {WorkQueueItem} from 'ApplicationEntry/models/WorkQueueItem';
import {StringUnion} from 'Core/models/EmptyString';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import './AWDStatus.sass';

type StatusProps = {
  statusList: Status;
  status: StringUnion;
  status2: StringUnion;
  status3: StringUnion;
  policyRecordStatus: StringUnion;
  workItemList?: WorkQueueItem[];
  statusTypeRowNo: number;
};

const StatusView = (props: StatusProps) => {
  const [awdStatusLabel, setAWDStatusLabel] = useState<HTMLLabelElement | null>();
  const dispatch = useDispatch();
  const {status, status2, status3, statusList} = props;

  useEffect(() => {
    if (isLoaded(statusList)) {
      if (props.statusTypeRowNo === 0) dispatch(AWDStatusActions.changeStatus(props.policyRecordStatus.value));
      if (props.statusTypeRowNo === 1) dispatch(AWDStatusActions.changeStatus2(props.policyRecordStatus.value));
      if (props.statusTypeRowNo === 2) dispatch(AWDStatusActions.changeStatus3(props.policyRecordStatus.value));
    }
  }, [statusList, dispatch, props.policyRecordStatus.value]);

  const changeStatusType = (workType: string, idx: number) => {
    if (idx === 0) {
      dispatch(AWDStatusActions.changeStatus(workType));
    } else if (idx === 1) {
      dispatch(AWDStatusActions.changeStatus2(workType));
    } else if (idx === 2) {
      dispatch(AWDStatusActions.changeStatus3(workType));
    }
  };

  const getStatusTypeValue = (rowNo: number) => {
    if (rowNo === 0) {
      return status.value;
    } else if (rowNo === 1) {
      return status2.value;
    } else if (rowNo === 2) {
      return status3.value;
    }
  };

  return (
    <>
      {matchStatus({
        Loading: () => (
          <Grid item xs={12} md={3}>
            <FormControl variant="outlined" className="awdStatus-section__view-form-text-field">
              <InputLabel ref={setAWDStatusLabel} id="awdStatus-status-label">
                Status
              </InputLabel>
              <Select
                labelId="awdStatus-label-status"
                labelWidth={awdStatusLabel?.clientWidth}
                id="awdStatus-status"
                value={status.value}
                onChange={e => dispatch(AWDStatusActions.changeStatus(e.target.value as string))}
                displayEmpty
              >
                <MenuItem value="">&nbsp;&nbsp;</MenuItem>
              </Select>
              {isLoading(statusList) ? (
                <CircularProgress className="awdStatus-section__view-form-loading-icon" />
              ) : null}
            </FormControl>
          </Grid>
        ),
        Loaded: pn => (
          <Grid item xs={12} md={3}>
            <FormControl variant="outlined" className="awdStatus-section__view-form-text-field">
              <InputLabel ref={setAWDStatusLabel} id="awdStatus-status-label">
                Status
              </InputLabel>
              <Select
                labelId="awdStatus-label-status"
                labelWidth={awdStatusLabel?.clientWidth}
                id="awdStatus-status"
                value={getStatusTypeValue(props.statusTypeRowNo)}
                onChange={e => changeStatusType(e.target.value as string, props.statusTypeRowNo)}
                displayEmpty
              >
                {isLoaded(statusList) ? (
                  statusList.Data.map(rel => (
                    <MenuItem value={rel} key={rel}>
                      {rel}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">&nbsp;&nbsp;</MenuItem>
                )}
              </Select>
              {isLoading(statusList) ? (
                <CircularProgress className="awdStatus-section__view-form-loading-icon" />
              ) : null}
            </FormControl>
          </Grid>
        ),
        Unassigned: () => (
          <Grid item xs={12} md={3}>
            <FormControl variant="outlined" className="awdStatus-section__view-form-text-field">
              <InputLabel ref={setAWDStatusLabel} id="awdStatus-status-label">
                Status
              </InputLabel>
              <Select
                labelId="awdStatus-label-status"
                labelWidth={awdStatusLabel?.clientWidth}
                id="awdStatus-status"
                value={status.value}
                onChange={e => dispatch(AWDStatusActions.changeStatus(e.target.value as string))}
                displayEmpty
              >
                <MenuItem value="">&nbsp;&nbsp;</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        ),
        Error: () => (
          <Grid item xs={12} md={3}>
            <FormControl error variant="outlined" className="awdStatus-section__view-form-text-field">
              <InputLabel ref={setAWDStatusLabel} id="awdStatus-status-label">
                Status
              </InputLabel>
              <Select
                labelId="awdStatus-label-status"
                labelWidth={awdStatusLabel?.clientWidth}
                id="awdStatus-status"
                value={status.value}
                onChange={e => dispatch(AWDStatusActions.changeStatus(e.target.value as string))}
                displayEmpty
              >
                <MenuItem value="">&nbsp;&nbsp;</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        ),
      })(statusList)}
    </>
  );
};

export default StatusView;
